import { render, staticRenderFns } from "./ScoradParameterNode.vue?vue&type=template&id=dfccb54a&scoped=true&"
import script from "./ScoradParameterNode.vue?vue&type=script&lang=js&"
export * from "./ScoradParameterNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfccb54a",
  null
  
)

export default component.exports